"use client"

import clsx from "clsx"
import React from "react"

import BioModalCard from "../../BioModalCard"
import Button from "../../Button"
import PageGrid from "../../PageGrid"

interface allEventsProps {
  data: any[]
  title?: string
  limit?: number
  button?: boolean
  buttonCTA?: string
  buttonLink?: string
  id?: string
  lightmode?: boolean
}
const Speakers: React.FC<allEventsProps> = ({
  data,
  title,
  limit,
  button = false,
  buttonCTA,
  buttonLink,
  id = "unique",
  lightmode = true,
}) => (
  <section
    className={clsx(
      "py-10 lg:py-20",
      lightmode ? "bg-white-100 text-newblue-90" : "bg-gray-90 text-gray-2.5",
    )}
  >
    {title && (
      <PageGrid>
        <div className="col-span-full">
          <h4 className="mb-10 heading1 md:headline4">{title}</h4>
        </div>
      </PageGrid>
    )}
    <PageGrid>
      {data.slice(0, limit || data.length).map((person) => (
        <BioModalCard
          key={`${person.name}-${id}`}
          name={person.name}
          title={person.title}
          company={person.company}
          bio={person.biography}
          linkedIn={person.linkedIn}
          imgUrl={person.bioImage.url}
          lightmode={lightmode}
        />
      ))}
    </PageGrid>
    {button && (
      <PageGrid>
        <div className="text-center col-span-full py-10 mx-auto">
          <Button className="flex" size="md" to={buttonLink}>
            {buttonCTA}
          </Button>
        </div>
      </PageGrid>
    )}
  </section>
)

export default Speakers
